<div class="row utils-bar">
  <div></div>
  <mat-paginator [pageSizeOptions]="[10, 20, 50, 100, 200]" [pageSize]="pageSize"
                 showFirstLastButtons></mat-paginator>
</div>
<table mat-table class="table-striped" matSort [dataSource]="dataSource" [matSortActive]="'created_on'"
       matSortDirection="desc">

  <ng-container matColumnDef="details">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element">
      <a [routerLink]="['./', element.id]" matTooltip="View job details">
        <i class="fa-solid fa-file-circle-plus"></i>
      </a>
    </td>
  </ng-container>

  <ng-container matColumnDef="type">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Type</th>
    <td mat-cell *matCellDef="let element" [matTooltip]=""> {{element.attributes.type | removeUnderscore | titlecase}}</td>
  </ng-container>

  <ng-container matColumnDef="created_on">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Submitted On</th>
    <td mat-cell *matCellDef="let element"> {{element.attributes.created_on | stringDate}}</td>
  </ng-container>

  <ng-container matColumnDef="changed_on">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Last update</th>
    <td mat-cell *matCellDef="let element" [matTooltip]=""> {{element.attributes.changed_on | stringDate}}</td>
  </ng-container>

  <ng-container matColumnDef="total_time">
    <th mat-header-cell *matHeaderCellDef> Total Time</th>
    <td mat-cell *matCellDef="let element"> {{getExecutionTime(element)}}</td>
  </ng-container>

  <ng-container matColumnDef="created_by_name">
    <th mat-header-cell *matHeaderCellDef> Actioned by</th>
    <td mat-cell
        *matCellDef="let element">{{element.attributes.created_by_name + ' ' + (element.attributes.created_by_lastname || '')}}
    </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Status</th>
    <td mat-cell *matCellDef="let element">
      <src-job-status [status]="element.attributes.status"></src-job-status>
    </td>
  </ng-container>


  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell" [attr.colspan]="displayedColumns.length">
      No data matching the filter.
    </td>
  </tr>
</table>
